<template>
  <div id="Activation" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="go_back()"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">A</span>ctivación</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt10 pb10 pl20 pr20 color-muted">
      Después de la confirmación, se deducirán <span class="f16 fw color-danger" v-if="from_store > 0">150</span> <span class="f16 fw color-danger" v-else>300</span> puntos de su cuenta.
    </div>
    <div class="col-12 t-c pt10 pb15 fw">
      RIF <br /><span class="f30 fw color-success">{{rif}}</span>
    </div>
    <div class="col-12 t-c-v">
      <div class="fl mr5">
        <select class="lh20 h4" v-model="store" :disabled="from_store > 0">
            <option value="1">TIENDA 01</option>
            <option value="2">TIENDA 02</option>
            <option value="3">TIENDA 03</option>
            <option value="4">TIENDA 04</option>
            <option value="5">TIENDA 05</option>
            <option value="6">TIENDA 06</option>
            <option value="7">TIENDA 07</option>
            <option value="8">TIENDA 08</option>
            <option value="9">TIENDA 09</option>
            <option value="10">TIENDA 10</option>
            <option value="11">TIENDA 11</option>
            <option value="12">TIENDA 12</option>
            <option value="13">TIENDA 13</option>
            <option value="14">TIENDA 14</option>
            <option value="15">TIENDA 15</option>
            <option value="16">TIENDA 16</option>
            <option value="17">TIENDA 17</option>
            <option value="18">TIENDA 18</option>
            <option value="19">TIENDA 19</option>
            <option value="20">TIENDA 20</option>
        </select>   
      </div>
      <div class="fl mr5">
        <select class="lh20 h4" v-model="caja">
            <option value="1" selected>CAJA 01</option>
            <option value="2">CAJA 02</option>
            <option value="3">CAJA 03</option>
            <option value="4">CAJA 04</option>
            <option value="5">CAJA 05</option>
            <option value="6">CAJA 06</option>
            <option value="7">CAJA 07</option>
            <option value="8">CAJA 08</option>
            <option value="9">CAJA 09</option>
            <option value="10">CAJA 10</option>
            <option value="11">CAJA 11</option>
            <option value="12">CAJA 12</option>
            <option value="13">CAJA 13</option>
            <option value="14">CAJA 14</option>
            <option value="15">CAJA 15</option>
            <option value="16">CAJA 16</option>
            <option value="17">CAJA 17</option>
            <option value="18">CAJA 18</option>
            <option value="19">CAJA 19</option>
            <option value="20">CAJA 20</option>
            <option value="21">CAJA 21</option>
            <option value="22">CAJA 22</option>
            <option value="23">CAJA 23</option>
            <option value="24">CAJA 24</option>
            <option value="25">CAJA 25</option>
            <option value="26">CAJA 26</option>
            <option value="27">CAJA 27</option>
            <option value="28">CAJA 28</option>
            <option value="29">CAJA 29</option>
            <option value="30">CAJA 30</option>
        </select>
      </div>
      <div class="fl">
        <input type="button" value="Confirmar" class="b1 h4 pl15 pr15 r5 f12 bg-color-primary color-white" @click="act_confim()">
      </div>
    </div>
    <div class="h5"></div>
  </div>
</template>
<script>
export default {
  name: 'Activation',
  data () {
    return {
      rif: '',
      store: 1,
      caja: 1,
      act_type: 0,
      from_store: ''
    }
  },
  created: function () {
    this.rif = this.$route.params.rif;
    if(this.$route.params.act_type == 1){
      this.store = this.$route.params.store;
      this.from_store = this.$route.params.store;
    }
    this.act_type = this.$route.params.act_type;
    console.log(this.from_store)
  },
  methods: {
    act_confim(){
      this.$store.commit('setConfimBox',{type:'confim_exit',msg:'¿Estás seguro de continuar?',_this:this,focus:'',method:'act_now',arg1:''});
    },
    act_now() {
      var post_data = {};
      post_data.rif = this.rif;
      post_data.store = this.store;
      post_data.caja = this.caja;
      post_data.act_type = this.act_type;
      this.post(this.api_url + 'Tec/activation_now',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setClientKeyword', this.rif);
          this.$router.go(-1);
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    go_back(){
      this.$store.commit('setClientKeyword', '');
      this.$router.go(-1);
    }
  },
  watch: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Fun/Activation.vue